import React from 'react';
import PageTop from '../../../core/components/PageTop';
import VendorListTable from './table/VendorListTable';
import { useVendorListInit } from './pagehooks/useVendorListInit';

const PageAdminVendorList = (): JSX.Element => {
    useVendorListInit();

    return (
        <>
            <PageTop
                title="Vendor List"
                icon="sprite-vendor"
            />
            <div className="vendor-feature vendor-list">
                <VendorListTable />
            </div>
        </>
    );
};

export default PageAdminVendorList;
